// eslint-disable-next-line no-unused-vars
var itemsGer = {
    "1": "Meisterball",
    "2": "Hyperball",
    "3": "Superball",
    "4": "Pokéball",
    "5": "Safariball",
    "6": "Netzball",
    "7": "Tauchball",
    "8": "Nestball",
    "9": "Wiederball",
    "10": "Timerball",
    "11": "Luxusball",
    "12": "Premierball",
    "13": "Finsterball",
    "14": "Heilball",
    "15": "Flottball",
    "16": "Jubelball",
    "17": "Trank",
    "18": "Gegengift",
    "19": "Feuerheiler",
    "20": "Eisheiler",
    "21": "Aufwecker",
    "22": "Para-Heiler",
    "23": "Top-Genesung",
    "24": "Top-Trank",
    "25": "Hypertrank",
    "26": "Supertrank",
    "27": "Hyperheiler",
    "28": "Beleber",
    "29": "Top-Beleber",
    "30": "Tafelwasser",
    "31": "Sprudel",
    "32": "Limonade",
    "33": "Kuhmuh-Milch",
    "34": "Energiestaub",
    "35": "Kraftwurzel",
    "36": "Heilpuder",
    "37": "Vitalkraut",
    "38": "\u00c4ther",
    "39": "Top-\u00c4ther",
    "40": "Elixier",
    "41": "Top-Elixier",
    "42": "Lavakeks",
    "43": "Beerensaft",
    "44": "Zauberasche",
    "45": "KP-Plus",
    "46": "Protein",
    "47": "Eisen",
    "48": "Carbon",
    "49": "Kalzium",
    "50": "Sonderbonbon",
    "51": "AP-Plus",
    "52": "Zink",
    "53": "AP-Top",
    "54": "Spezialit\u00e4t",
    "55": "Megablock",
    "56": "X-Volltreffer",
    "57": "X-Angriff",
    "58": "X-Verteidigung",
    "59": "X-Initiative",
    "60": "X-Genauigkeit",
    "61": "X-Sp.-Ang.",
    "62": "X-Sp.-Vert.",
    "63": "Poképuppe",
    "64": "Eneco-Rute",
    "65": "Blaue Fl\u00f6te",
    "66": "Gelbe Fl\u00f6te",
    "67": "Rote Fl\u00f6te",
    "68": "Schwarze Fl\u00f6te",
    "69": "Wei\u00dfe Fl\u00f6te",
    "70": "K\u00fcstensalz",
    "71": "K\u00fcstenschale",
    "72": "Purpurst\u00fcck",
    "73": "Indigost\u00fcck",
    "74": "Gelbst\u00fcck",
    "75": "Gr\u00fcnst\u00fcck",
    "76": "Superschutz",
    "77": "Top-Schutz",
    "79": "Schutz",
    "80": "Sonnenstein",
    "81": "Mondstein",
    "82": "Feuerstein",
    "83": "Donnerstein",
    "84": "Wasserstein",
    "85": "Blattstein",
    "86": "Minipilz",
    "87": "Riesenpilz",
    "88": "Perle",
    "89": "Riesenperle",
    "90": "Sternenstaub",
    "91": "Sternenst\u00fcck",
    "92": "Nugget",
    "93": "Herzschuppe",
    "94": "Honig",
    "95": "Wachsmulch",
    "96": "Feuchtmulch",
    "97": "Stabilmulch",
    "98": "Neumulch",
    "99": "Wurzelfossil",
    "100": "Klauenfossil",
    "101": "Helixfossil",
    "102": "Domfossil",
    "103": "Altbernstein",
    "104": "Panzerfossil",
    "105": "Kopffossil",
    "106": "Steinknochen",
    "107": "Leuchtstein",
    "108": "Finsterstein",
    "109": "Funkelstein",
    "110": "Ovaler Stein",
    "111": "Spiritkern",
    "112": "Platinum-Orb",
    "116": "Aquamodul",
    "117": "Blitzmodul",
    "118": "Flammenmodul",
    "119": "Gefriermodul",
    "120": "???",
    "129": "???",
    "130": "???",
    "131": "???",
    "132": "???",
    "133": "???",
    "134": "Herzkonfekt",
    "135": "Adamant-Orb",
    "136": "Wei\u00df-Orb",
    "137": "Gru\u00dfbrief",
    "138": "Faiblebrief",
    "139": "Einladebrief",
    "140": "Dankesbrief",
    "141": "Fragebrief",
    "142": "Insiderbrief",
    "143": "R\u00fcckbrief",
    "144": "Br\u00fcckbrief H",
    "145": "Br\u00fcckbrief M",
    "146": "Br\u00fcckbrief Z",
    "147": "Br\u00fcckbrief D",
    "148": "Br\u00fcckbrief W",
    "149": "Amrenabeere",
    "150": "Maronbeere",
    "151": "Pirsifbeere",
    "152": "Fragiabeere",
    "153": "Wilbirbeere",
    "154": "Jonagobeere",
    "155": "Sinelbeere",
    "156": "Persimbeere",
    "157": "Prunusbeere",
    "158": "Tsitrubeere",
    "159": "Giefebeere",
    "160": "Wikibeere",
    "161": "Magobeere",
    "162": "Gauvebeere",
    "163": "Yapabeere",
    "164": "Himmihbeere",
    "165": "Morbbeere",
    "166": "Nanabbeere",
    "167": "Nirbebeere",
    "168": "Sananabeere",
    "169": "Granabeere",
    "170": "Setangbeere",
    "171": "Qualotbeere",
    "172": "Honmelbeere",
    "173": "Labrusbeere",
    "174": "Tamotbeere",
    "175": "Saimbeere",
    "176": "Magostbeere",
    "177": "Rabutabeere",
    "178": "Tronzibeere",
    "179": "Kiwanbeere",
    "180": "Pallmbeere",
    "181": "Wasmelbeere",
    "182": "Durinbeere",
    "183": "Myrtilbeere",
    "184": "Koakobeere",
    "185": "Foepasbeere",
    "186": "Kerzalbeere",
    "187": "Grindobeere",
    "188": "Kiroyabeere",
    "189": "Rospelbeere",
    "190": "Grarzbeere",
    "191": "Schukebeere",
    "192": "Kobabeere",
    "193": "Pyapabeere",
    "194": "Tanigabeere",
    "195": "Chiaribeere",
    "196": "Zitarzbeere",
    "197": "Terirobeere",
    "198": "Burleobeere",
    "199": "Babiribeere",
    "200": "Latchibeere",
    "201": "Lydzibeere",
    "202": "Linganbeere",
    "203": "Salkabeere",
    "204": "Tahaybeere",
    "205": "Apikobeere",
    "206": "Lansatbeere",
    "207": "Krambobeere",
    "208": "Enigmabeere",
    "209": "Wunfrubeere",
    "210": "Eipfelbeere",
    "211": "Jabocabeere",
    "212": "Roselbeere",
    "213": "Blendpuder",
    "214": "Schlohkraut",
    "215": "Machoschiene",
    "217": "Flinkklaue",
    "218": "Sanftglocke",
    "219": "Mentalkraut",
    "220": "Wahlband",
    "221": "King-Stein",
    "222": "Silberstaub",
    "223": "M\u00fcnzamulett",
    "224": "Schutzsticker",
    "225": "Seelentau",
    "226": "Abysszahn",
    "227": "Abyssschuppe",
    "228": "Rauchball",
    "229": "Ewigstein",
    "230": "Fokusband",
    "231": "Gl\u00fccks-Ei",
    "232": "Scope-Linse",
    "233": "Metallmantel",
    "234": "\u00dcberreste",
    "235": "Drachenschuppe",
    "236": "Kugelblitz",
    "237": "Pudersand",
    "238": "Granitstein",
    "239": "Wundersaat",
    "240": "Schattenbrille",
    "241": "Schwarzgurt",
    "242": "Magnet",
    "243": "Zauberwasser",
    "244": "Spitzer Schnabel",
    "245": "Giftstich",
    "246": "Ewiges Eis",
    "247": "Bannsticker",
    "248": "Krumml\u00f6ffel",
    "249": "Holzkohle",
    "250": "Drachenzahn",
    "251": "Seidenschal",
    "252": "Upgrade",
    "253": "Muschelglocke",
    "254": "Seerauch",
    "255": "Laxrauch",
    "256": "Lucky Punch",
    "257": "Metallstaub",
    "258": "Kampfknochen",
    "259": "Lauchstange",
    "260": "Roter Schal",
    "261": "Blauer Schal",
    "262": "Rosa Schal",
    "263": "Gr\u00fcner Schal",
    "264": "Gelber Schal",
    "265": "Gro\u00dflinse",
    "266": "Muskelband",
    "267": "Schlaubrille",
    "268": "Expertengurt",
    "269": "Lichtlehm",
    "270": "Leben-Orb",
    "271": "Energiekraut",
    "272": "Toxik-Orb",
    "273": "Hei\u00df-Orb",
    "274": "Flottstaub",
    "275": "Fokusgurt",
    "276": "Zoomlinse",
    "277": "Metronom",
    "278": "Eisenkugel",
    "279": "Schwerschweif",
    "280": "Fatumknoten",
    "281": "Giftschleim",
    "282": "Eisbrocken",
    "283": "Glattbrocken",
    "284": "Hei\u00dfbrocken",
    "285": "Nassbrocken",
    "286": "Griffklaue",
    "287": "Wahlschal",
    "288": "Klettdorn",
    "289": "Machtreif",
    "290": "Machtgurt",
    "291": "Machtlinse",
    "292": "Machtband",
    "293": "Machtkette",
    "294": "Machtgewicht",
    "295": "Wechselh\u00fclle",
    "296": "Gro\u00dfwurzel",
    "297": "Wahlbrille",
    "298": "Feuertafel",
    "299": "Wassertafel",
    "300": "Blitztafel",
    "301": "Wiesentafel",
    "302": "Frosttafel",
    "303": "Fausttafel",
    "304": "Gifttafel",
    "305": "Erdtafel",
    "306": "Wolkentafel",
    "307": "Hirntafel",
    "308": "K\u00e4fertafel",
    "309": "Steintafel",
    "310": "Spuktafel",
    "311": "Dracotafel",
    "312": "Furchttafel",
    "313": "Eisentafel",
    "314": "Schr\u00e4grauch",
    "315": "Steinrauch",
    "316": "Lahmrauch",
    "317": "Wellenrauch",
    "318": "Rosenrauch",
    "319": "Gl\u00fccksrauch",
    "320": "Scheuchrauch",
    "321": "Sch\u00fctzer",
    "322": "Stromisierer",
    "323": "Magmaisierer",
    "324": "Dubiosdisc",
    "325": "D\u00fcsterumhang",
    "326": "Scharfklaue",
    "327": "Scharfzahn",
    "328": "TM001",
    "329": "TM002",
    "330": "TM003",
    "331": "TM004",
    "332": "TM005",
    "333": "TM006",
    "334": "TM007",
    "335": "TM008",
    "336": "TM009",
    "337": "TM010",
    "338": "TM011",
    "339": "TM012",
    "340": "TM013",
    "341": "TM014",
    "342": "TM015",
    "343": "TM016",
    "344": "TM017",
    "345": "TM018",
    "346": "TM019",
    "347": "TM020",
    "348": "TM021",
    "349": "TM022",
    "350": "TM023",
    "351": "TM024",
    "352": "TM025",
    "353": "TM026",
    "354": "TM027",
    "355": "TM028",
    "356": "TM029",
    "357": "TM030",
    "358": "TM031",
    "359": "TM032",
    "360": "TM033",
    "361": "TM034",
    "362": "TM035",
    "363": "TM036",
    "364": "TM037",
    "365": "TM038",
    "366": "TM039",
    "367": "TM040",
    "368": "TM041",
    "369": "TM042",
    "370": "TM043",
    "371": "TM044",
    "372": "TM045",
    "373": "TM046",
    "374": "TM047",
    "375": "TM048",
    "376": "TM049",
    "377": "TM050",
    "378": "TM051",
    "379": "TM052",
    "380": "TM053",
    "381": "TM054",
    "382": "TM055",
    "383": "TM056",
    "384": "TM057",
    "385": "TM058",
    "386": "TM059",
    "387": "TM060",
    "388": "TM061",
    "389": "TM062",
    "390": "TM063",
    "391": "TM064",
    "392": "TM065",
    "393": "TM066",
    "394": "TM067",
    "395": "TM068",
    "396": "TM069",
    "397": "TM070",
    "398": "TM071",
    "399": "TM072",
    "400": "TM073",
    "401": "TM074",
    "402": "TM075",
    "403": "TM076",
    "404": "TM077",
    "405": "TM078",
    "406": "TM079",
    "407": "TM080",
    "408": "TM081",
    "409": "TM082",
    "410": "TM083",
    "411": "TM084",
    "412": "TM085",
    "413": "TM086",
    "414": "TM087",
    "415": "TM088",
    "416": "TM089",
    "417": "TM090",
    "418": "TM091",
    "419": "TM092",
    "426": "TM099",
    "427": "TM100",
    "428": "Erkundungs-Set",
    "429": "Beutesack",
    "430": "Regelbuch",
    "432": "Punktekarte",
    "433": "Abenteuernotizen",
    "434": "Stickerkoffer",
    "435": "Modekoffer",
    "436": "Stickert\u00fcte",
    "437": "Adressbuch",
    "438": "K-Schl\u00fcssel",
    "439": "Talisman",
    "441": "Rote Kette",
    "443": "Kampffahnder",
    "444": "M\u00fcnzkorb",
    "448": "Enton-Kanne",
    "449": "Knurspbox",
    "451": "Hotelschl\u00fcssel",
    "452": "Eichs Brief",
    "453": "Lunarfeder",
    "454": "Mitgliedskarte",
    "455": "Azurfl\u00f6te",
    "456": "Bootsticket",
    "458": "Magmastein",
    "459": "Paket",
    "460": "Coupon 1",
    "461": "Coupon 2",
    "462": "Coupon 3",
    "463": "Lagerschl\u00fcssel",
    "464": "Geheimmedizin",
    "467": "Geheimschl\u00fcssel",
    "468": "Aprikokobox",
    "469": "Icognitoheft",
    "470": "Pflanzset",
    "472": "Blaue Karte",
    "473": "Flegmon-Rute",
    "475": "Schl\u00fcsselkarte",
    "476": "Keller\u00f6ffner",
    "477": "Schiggykanne",
    "478": "Rote Schuppe",
    "479": "Fundsache",
    "480": "Fahrschein",
    "481": "Spule",
    "482": "Silberfl\u00fcgel",
    "483": "Buntschwinge",
    "484": "R\u00e4tsel-Ei",
    "485": "Aprikoko Rot",
    "486": "Aprikoko Blau",
    "487": "Aprikoko Gelb",
    "488": "Aprikoko Gr\u00fcn",
    "489": "Aprikoko Pink",
    "490": "Aprikoko Wei\u00df",
    "491": "Aprikoko Schwarz",
    "492": "Turboball",
    "493": "Levelball",
    "494": "K\u00f6derball",
    "495": "Schwerball",
    "496": "Sympaball",
    "497": "Freundesball",
    "498": "Mondball",
    "499": "Turnierball",
    "501": "Fotoalbum",
    "502": "GB-Player",
    "504": "Wutkeks",
    "505": "Datenkarte01",
    "506": "Datenkarte02",
    "507": "Datenkarte03",
    "508": "Datenkarte04",
    "509": "Datenkarte05",
    "510": "Datenkarte06",
    "511": "Datenkarte07",
    "512": "Datenkarte08",
    "513": "Datenkarte09",
    "514": "Datenkarte10",
    "515": "Datenkarte11",
    "516": "Datenkarte12",
    "517": "Datenkarte13",
    "518": "Datenkarte14",
    "519": "Datenkarte15",
    "520": "Datenkarte16",
    "521": "Datenkarte17",
    "522": "Datenkarte18",
    "523": "Datenkarte19",
    "524": "Datenkarte20",
    "525": "Datenkarte21",
    "526": "Datenkarte22",
    "527": "Datenkarte23",
    "528": "Datenkarte24",
    "529": "Datenkarte25",
    "530": "Datenkarte26",
    "531": "Datenkarte27",
    "532": "Gr\u00fcne Kugel",
    "533": "Tresorkapsel",
    "534": "Roter Edelstein",
    "535": "Blauer Edelstein",
    "536": "Mytokristall",
    "537": "Sch\u00f6nschuppe",
    "538": "Evolith",
    "539": "Leichtstein",
    "540": "Beulenhelm",
    "541": "Luftballon",
    "542": "Rote Karte",
    "543": "Zielscheibe",
    "544": "Klammerband",
    "545": "Knolle",
    "546": "Akku",
    "547": "Fluchtknopf",
    "548": "Feuerjuwel",
    "549": "Wasserjuwel",
    "550": "Elektrojuwel",
    "551": "Pflanzenjuwel",
    "552": "Eisjuwel",
    "553": "Kampfjuwel",
    "554": "Giftjuwel",
    "555": "Bodenjuwel",
    "556": "Flugjuwel",
    "557": "Psychojuwel",
    "558": "K\u00e4ferjuwel",
    "559": "Gesteinsjuwel",
    "560": "Geisterjuwel",
    "561": "Drakojuwel",
    "562": "Unlichtjuwel",
    "563": "Stahljuwel",
    "564": "Normaljuwel",
    "565": "Heilfeder",
    "566": "Kraftfeder",
    "567": "Abwehrfeder",
    "568": "Geniefeder",
    "569": "Espritfeder",
    "570": "Flinkfeder",
    "571": "Prachtfeder",
    "572": "Schildfossil",
    "573": "Federfossil",
    "574": "Gartenpass",
    "575": "Transfer-Orb",
    "576": "Traumball",
    "577": "Pokéwedel",
    "578": "Deko-Box",
    "579": "Drakosch\u00e4del",
    "580": "Duftpilz",
    "581": "Riesennugget",
    "582": "Triperle",
    "583": "Kometst\u00fcck",
    "584": "Alter Heller",
    "585": "Alter Taler",
    "586": "Alter Dukat",
    "587": "Alte Vase",
    "588": "Alter Reif",
    "589": "Alte Statue",
    "590": "Alte Krone",
    "591": "Stratos-Eis",
    "592": "X-Volltreffer 2",
    "593": "X-Initiative 2",
    "594": "X-Sp.-Ang. 2",
    "595": "X-Sp.-Vert. 2",
    "596": "X-Verteidigung 2",
    "597": "X-Angriff 2",
    "598": "X-Genauigkeit 2",
    "599": "X-Initiative 3",
    "600": "X-Sp.-Ang. 3",
    "601": "X-Sp.-Vert. 3",
    "602": "X-Verteidigung 3",
    "603": "X-Angriff 3",
    "604": "X-Genauigkeit 3",
    "605": "X-Initiative 6",
    "606": "X-Sp.-Ang. 6",
    "607": "X-Sp.-Vert. 6",
    "608": "X-Verteidigung 6",
    "609": "X-Angriff 6",
    "610": "X-Genauigkeit 6",
    "611": "F\u00e4higkeiten-Appell",
    "612": "Itemabwurf",
    "613": "Itemappell",
    "614": "Umkehrappell",
    "615": "X-Volltreffer 3",
    "616": "Lichtstein",
    "617": "Dunkelstein",
    "618": "TM093",
    "619": "TM094",
    "620": "TM095",
    "621": "Viso-Caster",
    "622": "???",
    "623": "Briefpost 1",
    "624": "Briefpost 2",
    "625": "Briefpost 3",
    "626": "Viso-Caster",
    "627": "Medaillenbox",
    "630": "Genehmigung",
    "633": "Plasmakarte",
    "634": "Schn\u00e4uztuch",
    "635": "Achromat",
    "636": "Fundsache",
    "637": "Fundsache",
    "639": "Schw\u00e4chenschutz",
    "640": "Offensivweste",
    "644": "Feentafel",
    "645": "F\u00e4higkeiten-Kapsel",
    "646": "Sahneh\u00e4ubchen",
    "647": "Duftbeutel",
    "648": "Leuchtmoos",
    "649": "Schneeball",
    "650": "Schutzbrille",
    "652": "Sprie\u00dfmulch",
    "653": "Wundermulch",
    "654": "Wuchermulch",
    "655": "Ultramulch",
    "656": "Gengarnit",
    "657": "Guardevoirnit",
    "658": "Ampharosnit",
    "659": "Bisaflornit",
    "660": "Gluraknit X",
    "661": "Turtoknit",
    "662": "Mewtunit X",
    "663": "Mewtunit Y",
    "664": "Lohgocknit",
    "665": "Meditalisnit",
    "666": "Hundemonit",
    "667": "Stollossnit",
    "668": "Banetteonit",
    "669": "Despotarnit",
    "670": "Scheroxnit",
    "671": "Pinsirnit",
    "672": "Aerodactylonit",
    "673": "Lucarionit",
    "674": "Rexblisarnit",
    "675": "Kangamanit",
    "676": "Garadosnit",
    "677": "Absolnit",
    "678": "Gluraknit Y",
    "679": "Simsalanit",
    "680": "Skarabornit",
    "681": "Flunkifernit",
    "682": "Voltensonit",
    "683": "Knakracknit",
    "684": "Latiasnit",
    "685": "Latiosnit",
    "686": "Hibisbeere",
    "687": "Akibeere",
    "688": "Tarabeere",
    "690": "TM096",
    "691": "TM097",
    "692": "TM098",
    "693": "TM099",
    "694": "TM100",
    "699": "Rabattmarke",
    "704": "Skurriloskulptur",
    "708": "Illumina-Galette",
    "709": "Yantara-Sablé",
    "710": "Kieferfossil",
    "711": "Flossenfossil",
    "715": "Feenjuwel",
    "752": "Sumpexnit",
    "753": "Gewaldronit",
    "754": "Zobirisnit",
    "755": "Altarianit",
    "756": "Galagladinit",
    "757": "Ohrdochnit",
    "758": "Metagrossnit",
    "759": "Tohaidonit",
    "760": "Lahmusnit",
    "761": "Stahlosnit",
    "762": "Taubossnit",
    "763": "Firnontornit",
    "764": "Diancienit",
    "767": "Cameruptnit",
    "768": "Schlapornit",
    "769": "Brutalandanit",
    "770": "Bibornit",
    "776": "Normium Z",
    "777": "Pyrium Z",
    "778": "Aquium Z",
    "779": "Voltium Z",
    "780": "Botanium Z",
    "781": "Glacium Z",
    "782": "Battalium Z",
    "783": "Toxium Z",
    "784": "Terrium Z",
    "785": "Aerium Z",
    "786": "Psium Z",
    "787": "Insectium Z",
    "788": "Petrium Z",
    "789": "Phantomium Z",
    "790": "Dracium Z",
    "791": "Noctium Z",
    "792": "Metallium Z",
    "793": "Sylphium Z",
    "794": "Pikachium Z",
    "795": "Silberkronkorken",
    "796": "Goldkronkorken",
    "798": "Silvarronium Z",
    "799": "Fuegronium Z",
    "800": "Primarenium Z",
    "801": "Kapium Z",
    "802": "Marshadownium Z",
    "803": "A-Raichunium Z",
    "804": "Relaxonium Z",
    "805": "Evolium Z",
    "806": "Mewnium Z",
    "807": "Normium Z",
    "808": "Pyrium Z",
    "809": "Aquium Z",
    "810": "Voltium Z",
    "811": "Botanium Z",
    "812": "Glacium Z",
    "813": "Battalium Z",
    "814": "Toxium Z",
    "815": "Terrium Z",
    "816": "Aerium Z",
    "817": "Psium Z",
    "818": "Insectium Z",
    "819": "Petrium Z",
    "820": "Phantomium Z",
    "821": "Dracium Z",
    "822": "Noctium Z",
    "823": "Metallium Z",
    "824": "Sylphium Z",
    "825": "Pikachium Z",
    "826": "Silvarronium Z",
    "827": "Fuegronium Z",
    "828": "Primarenium Z",
    "829": "Kapium Z",
    "830": "Marshadownium Z",
    "831": "A-Raichunium Z",
    "832": "Relaxonium Z",
    "833": "Evolium Z",
    "834": "Mewnium Z",
    "835": "Ash-Pikachium Z",
    "836": "Ash-Pikachium Z",
    "844": "Festival-Ticket",
    "846": "Zitter-Orb",
    "849": "Eisstein",
    "851": "Ultraball",
    "852": "Maxi-Malasada",
    "853": "Roter Nektar",
    "854": "Gelber Nektar",
    "855": "Rosa Nektar",
    "856": "Purpurner Nektar",
    "861": "Silberne Himmihbeere",
    "862": "Goldene Himmihbeere",
    "863": "Silberne Nanabbeere",
    "864": "Goldene Nanabbeere",
    "865": "Silberne Sananabeere",
    "866": "Goldene Sananabeere",
    "867": "???",
    "868": "???",
    "869": "???",
    "870": "???",
    "871": "???",
    "879": "Feldbeschichtung",
    "880": "Schutzpolster",
    "881": "Elektro-Samen",
    "882": "Psycho-Samen",
    "883": "Nebel-Samen",
    "884": "Gras-Samen",
    "885": "Spiralfeder",
    "886": "Kreidestein",
    "887": "Glasmurmel",
    "888": "Ohrring",
    "889": "Strandscherbe",
    "890": "Goldblatt",
    "891": "Silberblatt",
    "892": "Glanzkugel",
    "893": "Tropenmuschel",
    "894": "Blattbrief",
    "895": "Blattbrief",
    "896": "Ministrau\u00df",
    "897": "???",
    "898": "???",
    "899": "???",
    "900": "Lockparf\u00fcm",
    "901": "Super-Lockparf\u00fcm",
    "902": "Top-Lockparf\u00fcm",
    "903": "Marmoria-Kr\u00e4cker",
    "904": "Kampf-Disc",
    "905": "Flug-Disc",
    "906": "Gift-Disc",
    "907": "Boden-Disc",
    "908": "Gesteins-Disc",
    "909": "K\u00e4fer-Disc",
    "910": "Geister-Disc",
    "911": "Stahl-Disc",
    "912": "Feuer-Disc",
    "913": "Wasser-Disc",
    "914": "Pflanzen-Disc",
    "915": "Elektro-Disc",
    "916": "Psycho-Disc",
    "917": "Eis-Disc",
    "918": "Drachen-Disc",
    "919": "Unlicht-Disc",
    "920": "Feen-Disc",
    "921": "Solgalium Z",
    "922": "Lunalium Z",
    "923": "Ultranecronium Z",
    "924": "Mimigmium Z",
    "925": "Wolwerockium Z",
    "926": "Grandirasium Z",
    "927": "Solgalium Z",
    "928": "Lunalium Z",
    "929": "Ultranecronium Z",
    "930": "Mimigmium Z",
    "931": "Wolwerockium Z",
    "932": "Grandirasium Z",
    "949": "Brutbon",
    "950": "Schn\u00e4ppchenbon",
    "951": "Preisgeldbon",
    "952": "EP-Bon",
    "953": "Freundschaftsbon",
    "954": "Lockbon",
    "955": "Schutzbon",
    "956": "KP-Bon",
    "957": "AP-Bon",
    "958": "Statuswertebon",
    "959": "Fangbon",
    "960": "Energiebonbon",
    "961": "St\u00e4rkebonbon",
    "962": "Robustbonbon",
    "963": "Gripsbonbon",
    "964": "Mentalbonbon",
    "965": "Flottbonbon",
    "966": "Energiebonbon+",
    "967": "St\u00e4rkebonbon+",
    "968": "Robustbonbon+",
    "969": "Gripsbonbon+",
    "970": "Mentalbonbon+",
    "971": "Flottbonbon+",
    "972": "Energiebonbon++",
    "973": "St\u00e4rkebonbon++",
    "974": "Robustbonbon++",
    "975": "Gripsbonbon++",
    "976": "Mentalbonbon++",
    "977": "Flottbonbon++",
    "978": "Bisasam-Bonbon",
    "979": "Glumanda-Bonbon",
    "980": "Schiggy-Bonbon",
    "981": "Raupy-Bonbon",
    "982": "Hornliu-Bonbon",
    "983": "Taubsi-Bonbon",
    "984": "Rattfratz-Bonbon",
    "985": "Habitak-Bonbon",
    "986": "Rettan-Bonbon",
    "987": "Pikachu-Bonbon",
    "988": "Sandan-Bonbon",
    "989": "Nidoran[Character1:female ]-Bonbon",
    "990": "Nidoran[Character1:male ]-Bonbon",
    "991": "Piepi-Bonbon",
    "992": "Vulpix-Bonbon",
    "993": "Pummeluff-Bonbon",
    "994": "Zubat-Bonbon",
    "995": "Myrapla-Bonbon",
    "996": "Paras-Bonbon",
    "997": "Bluzuk-Bonbon",
    "998": "Digda-Bonbon",
    "999": "Mauzi-Bonbon",
    "1000": "Enton-Bonbon",
    "1001": "Menki-Bonbon",
    "1002": "Fukano-Bonbon",
    "1003": "Quapsel-Bonbon",
    "1004": "Abra-Bonbon",
    "1005": "Machollo-Bonbon",
    "1006": "Knofensa-Bonbon",
    "1007": "Tentacha-Bonbon",
    "1008": "Kleinstein-Bonbon",
    "1009": "Ponita-Bonbon",
    "1010": "Flegmon-Bonbon",
    "1011": "Magnetilo-Bonbon",
    "1012": "Porenta-Bonbon",
    "1013": "Dodu-Bonbon",
    "1014": "Jurob-Bonbon",
    "1015": "Sleima-Bonbon",
    "1016": "Muschas-Bonbon",
    "1017": "Nebulak-Bonbon",
    "1018": "Onix-Bonbon",
    "1019": "Traumato-Bonbon",
    "1020": "Krabby-Bonbon",
    "1021": "Voltobal-Bonbon",
    "1022": "Owei-Bonbon",
    "1023": "Tragosso-Bonbon",
    "1024": "Kicklee-Bonbon",
    "1025": "Nockchan-Bonbon",
    "1026": "Schlurp-Bonbon",
    "1027": "Smogon-Bonbon",
    "1028": "Rihorn-Bonbon",
    "1029": "Chaneira-Bonbon",
    "1030": "Tangela-Bonbon",
    "1031": "Kangama-Bonbon",
    "1032": "Seeper-Bonbon",
    "1033": "Goldini-Bonbon",
    "1034": "Sterndu-Bonbon",
    "1035": "Pantimos-Bonbon",
    "1036": "Sichlor-Bonbon",
    "1037": "Rossana-Bonbon",
    "1038": "Elektek-Bonbon",
    "1039": "Pinsir-Bonbon",
    "1040": "Tauros-Bonbon",
    "1041": "Karpador-Bonbon",
    "1042": "Lapras-Bonbon",
    "1043": "Ditto-Bonbon",
    "1044": "Evoli-Bonbon",
    "1045": "Porygon-Bonbon",
    "1046": "Amonitas-Bonbon",
    "1047": "Kabuto-Bonbon",
    "1048": "Aerodactyl-Bonbon",
    "1049": "Relaxo-Bonbon",
    "1050": "Arktos-Bonbon",
    "1051": "Zapdos-Bonbon",
    "1052": "Lavados-Bonbon",
    "1053": "Dratini-Bonbon",
    "1054": "Mewtu-Bonbon",
    "1055": "Mew-Bonbon",
    "1056": "Meltan-Bonbon",
    "1057": "Magmar-Bonbon",
    "1058": "???",
    "1059": "???",
    "1060": "???",
    "1061": "???",
    "1062": "???",
    "1063": "???",
    "1064": "???",
    "1065": "???",
    "1066": "???",
    "1067": "???",
    "1068": "???",
    "1069": "???",
    "1070": "???",
    "1071": "???",
    "1072": "???",
    "1073": "???",
    "1084": "W\u00fcrstchen",
    "1085": "Pauls Feinkost",
    "1086": "Bachs Feinkost",
    "1087": "Dosenbohnen",
    "1088": "Toastbrot",
    "1089": "Spaghetti",
    "1090": "Pilzmix",
    "1091": "R\u00f6strute",
    "1092": "Dicker Lauch",
    "1093": "Luxusapfel",
    "1094": "Feine Knochen",
    "1095": "Kartoffeln",
    "1096": "Uferkraut",
    "1097": "Gem\u00fcse",
    "1098": "Frittiertes",
    "1099": "Gekochtes Ei",
    "1103": "Rostiges Schwert",
    "1104": "Rostiger Schild",
    "1105": "Vogelfossil",
    "1106": "Fischfossil",
    "1107": "Drachenfossil",
    "1108": "Paddelfossil",
    "1109": "Zucker-Erdbeere",
    "1110": "Zucker-Herz",
    "1111": "Zucker-Beere",
    "1112": "Zucker-Kleeblatt",
    "1113": "Zucker-Blume",
    "1114": "Zucker-Stern",
    "1115": "Zucker-Schleife",
    "1116": "S\u00fc\u00dfer Apfel",
    "1117": "Saurer Apfel",
    "1118": "Halsspray",
    "1119": "Fluchttasche",
    "1120": "Plateauschuhe",
    "1121": "Fehlschlagschutz",
    "1122": "Bizarroservice",
    "1123": "Allzweckschirm",
    "1124": "EP-Bonbon XS",
    "1125": "EP-Bonbon S",
    "1126": "EP-Bonbon M",
    "1127": "EP-Bonbon L",
    "1128": "EP-Bonbon XL",
    "1129": "Dynamax-Bonbon",
    "1130": "TP00",
    "1131": "TP01",
    "1132": "TP02",
    "1133": "TP03",
    "1134": "TP04",
    "1135": "TP05",
    "1136": "TP06",
    "1137": "TP07",
    "1138": "TP08",
    "1139": "TP09",
    "1140": "TP10",
    "1141": "TP11",
    "1142": "TP12",
    "1143": "TP13",
    "1144": "TP14",
    "1145": "TP15",
    "1146": "TP16",
    "1147": "TP17",
    "1148": "TP18",
    "1149": "TP19",
    "1150": "TP20",
    "1151": "TP21",
    "1152": "TP22",
    "1153": "TP23",
    "1154": "TP24",
    "1155": "TP25",
    "1156": "TP26",
    "1157": "TP27",
    "1158": "TP28",
    "1159": "TP29",
    "1160": "TP30",
    "1161": "TP31",
    "1162": "TP32",
    "1163": "TP33",
    "1164": "TP34",
    "1165": "TP35",
    "1166": "TP36",
    "1167": "TP37",
    "1168": "TP38",
    "1169": "TP39",
    "1170": "TP40",
    "1171": "TP41",
    "1172": "TP42",
    "1173": "TP43",
    "1174": "TP44",
    "1175": "TP45",
    "1176": "TP46",
    "1177": "TP47",
    "1178": "TP48",
    "1179": "TP49",
    "1180": "TP50",
    "1181": "TP51",
    "1182": "TP52",
    "1183": "TP53",
    "1184": "TP54",
    "1185": "TP55",
    "1186": "TP56",
    "1187": "TP57",
    "1188": "TP58",
    "1189": "TP59",
    "1190": "TP60",
    "1191": "TP61",
    "1192": "TP62",
    "1193": "TP63",
    "1194": "TP64",
    "1195": "TP65",
    "1196": "TP66",
    "1197": "TP67",
    "1198": "TP68",
    "1199": "TP69",
    "1200": "TP70",
    "1201": "TP71",
    "1202": "TP72",
    "1203": "TP73",
    "1204": "TP74",
    "1205": "TP75",
    "1206": "TP76",
    "1207": "TP77",
    "1208": "TP78",
    "1209": "TP79",
    "1210": "TP80",
    "1211": "TP81",
    "1212": "TP82",
    "1213": "TP83",
    "1214": "TP84",
    "1215": "TP85",
    "1216": "TP86",
    "1217": "TP87",
    "1218": "TP88",
    "1219": "TP89",
    "1220": "TP90",
    "1221": "TP91",
    "1222": "TP92",
    "1223": "TP93",
    "1224": "TP94",
    "1225": "TP95",
    "1226": "TP96",
    "1227": "TP97",
    "1228": "TP98",
    "1229": "TP99",
    "1230": "TM00",
    "1231": "Solo-Minze",
    "1232": "Hart-Minze",
    "1233": "Frech-Minze",
    "1234": "Mutig-Minze",
    "1235": "K\u00fchn-Minze",
    "1236": "Pfiffig-Minze",
    "1237": "Lasch-Minze",
    "1238": "Locker-Minze",
    "1239": "M\u00e4\u00dfig-Minze",
    "1240": "Mild-Minze",
    "1241": "Hitzig-Minze",
    "1242": "Ruhig-Minze",
    "1243": "Still-Minze",
    "1244": "Zart-Minze",
    "1245": "Sacht-Minze",
    "1246": "Forsch-Minze",
    "1247": "Scheu-Minze",
    "1248": "Hastig-Minze",
    "1249": "Froh-Minze",
    "1250": "Naiv-Minze",
    "1251": "Ernst-Minze",
    "1252": "Wunschbrocken",
    "1253": "Rissige Kanne",
    "1254": "L\u00f6chrige Kanne",
    "1256": "Fr\u00fcchte",
    "1257": "Kuhmuh-K\u00e4se",
    "1258": "Gew\u00fcrzmix",
    "1259": "Frische Sahne",
    "1260": "Fertigcurry",
    "1261": "Kokosmilch",
    "1262": "Fertignudeln",
    "1263": "Frikadellen",
    "1264": "Giga-Pulver",
    "1265": "Wunschsplitter",
    "1268": "???",
    "1579": "Dyna-Honig",
    "1580": "Dyna-Pilz",
    "1581": "Galarnuss-Zweig",
    "1582": "Galarnuss-Reif",
    "1588": "R\u00fcstungserz",
    "1592": "Galarnuss-Kranz",
    "1604": "Dyna-Erz",
    "1606": "F\u00e4higkeiten-Pflaster",
    "1608": "Zeitruhegabe",
    "1609": "Raumruhegabe",
    "1610": "Ruhegabe",
    "1611": "Verbindungsschnur",
    "1612": "Heimatmuffin",
    "1613": "Aprikoko",
    "1614": "Jubelmuffin",
    "1615": "Kombivitamine",
    "1616": "Treffervitamine",
    "1617": "Wahlreishappen",
    "1618": "Doppelrettich",
    "1619": "Umkehrbratling",
    "1620": "Rundblatt",
    "1621": "Meistersamen",
    "1622": "Pokéball",
    "1623": "???",
    "1624": "Perma-Eis",
    "1625": "Selfe-Kralle",
    "1626": "Tobutz-Fangzahn",
    "1627": "Vesprit-Feder",
    "1628": "Glanzstein",
    "1629": "Elysien-Fl\u00f6te",
    "1630": "Arznei",
    "1631": "Superarznei",
    "1632": "Funkelhonig",
    "1633": "Munterreis",
    "1634": "Kullerbohne",
    "1635": "Z\u00e4hpilz",
    "1636": "Knirschmineral",
    "1637": "Holz",
    "1638": "K\u00f6nigsblatt",
    "1639": "Moorruhegabe",
    "1640": "Pokéball",
    "1641": "Superball",
    "1642": "Hyperball",
    "1643": "Federball",
    "1644": "Pokémon-Kokeshi",
    "1645": "???",
    "1646": "Rauchkugel",
    "1647": "Knallkugel",
    "1648": "Klebkugel",
    "1649": "Sternenst\u00fcck",
    "1650": "Pilzk\u00f6der",
    "1651": "Schutzblume",
    "1652": "Honigk\u00f6der",
    "1653": "Reisk\u00f6der",
    "1654": "Bohnenk\u00f6der",
    "1655": "Mineralk\u00f6der",
    "1656": "Trank",
    "1657": "Supertrank",
    "1658": "Hypertrank",
    "1659": "Top-Trank",
    "1660": "Top-Genesung",
    "1661": "Arznei",
    "1662": "Superarznei",
    "1663": "Hyperarznei",
    "1664": "Spezialit\u00e4t",
    "1665": "Jubelmuffin",
    "1666": "Hyperheiler",
    "1667": "Beleber",
    "1668": "Top-Beleber",
    "1669": "\u00c4therpillen",
    "1670": "Elixierpillen",
    "1671": "Schleichspray",
    "1672": "???",
    "1673": "Offensivvitamine",
    "1674": "Defensivvitamine",
    "1675": "Treffervitamine",
    "1676": "Ausweichvitamine",
    "1677": "Kombivitamine",
    "1678": "Waldruhegabe",
    "1679": "Eisenbrocken",
    "1680": "???",
    "1681": "Schwarzglanzstein",
    "1682": "Azurglanzstein",
    "1683": "???",
    "1684": "Lehmball",
    "1685": "???",
    "1686": "Knallmoos",
    "1687": "Rauchknolle",
    "1688": "L\u00f6chrige Aprikoko",
    "1689": "Schneeball",
    "1690": "Klebkugel",
    "1691": "Schwarzaugit",
    "1692": "Torfblock",
    "1693": "Schleichspray",
    "1694": "Fitlauch",
    "1695": "Vitalknospe",
    "1696": "\u00c4therkraut",
    "1697": "???",
    "1698": "???",
    "1699": "Wahrungstalisman 2",
    "1700": "Wahrungstalisman 3",
    "1701": "Schwertling",
    "1702": "Schildling",
    "1703": "Flinkling",
    "1704": "Volltrefferling",
    "1705": "Strandrettich",
    "1706": "Wahrungstalisman 4",
    "1707": "Wahrungstalisman 5",
    "1708": "S\u00fc\u00dftr\u00fcffel",
    "1709": "K\u00f6derteig",
    "1710": "Pokéball",
    "1711": "Superball",
    "1712": "Hyperball",
    "1713": "Federball",
    "1714": "???",
    "1715": "???",
    "1716": "Knallkugel",
    "1717": "Rauchkugel",
    "1718": "???",
    "1719": "???",
    "1720": "Pokémon-Kokeshi",
    "1721": "Vulkanruhegabe",
    "1722": "Bergruhegabe",
    "1723": "Schneeruhegabe",
    "1724": "Honigk\u00f6der",
    "1725": "Reisk\u00f6der",
    "1726": "Bohnenk\u00f6der",
    "1727": "Pilzk\u00f6der",
    "1728": "Mineralk\u00f6der",
    "1729": "Umkehrbratling",
    "1730": "Wahlreishappen",
    "1731": "Doppelrettich",
    "1732": "Schutztalisman 1",
    "1733": "Schutztalisman 2",
    "1734": "Schutztalisman 3",
    "1735": "Schutztalisman 4",
    "1736": "Schutztalisman 5",
    "1737": "Kaputtes Journal",
    "1738": "Statustalisman 1",
    "1739": "Statustalisman 2",
    "1740": "Statustalisman 3",
    "1741": "Statustalisman 4",
    "1742": "Statustalisman 5",
    "1743": "Plattenfragment",
    "1744": "Salmagnis-Klo\u00df",
    "1745": "Altes Journal",
    "1746": "Fl\u00fcgelball",
    "1747": "D\u00fcsenball",
    "1748": "Schwerball",
    "1749": "Zentnerball",
    "1750": "Tonnenball",
    "1751": "Fl\u00fcgelball",
    "1752": "D\u00fcsenball",
    "1753": "Schwerball",
    "1754": "Pfohbeere",
    "1755": "Hyperarznei",
    "1756": "Offensivvitamine",
    "1757": "Defensivvitamine",
    "1758": "Ausweichvitamine",
    "1759": "Leistungssand",
    "1760": "Leistungskies",
    "1761": "Leistungsstein",
    "1762": "Leistungsfels",
    "1763": "Geheimmedizin",
    "1764": "Wahrungstalisman 1",
    "1765": "Verlorene Items",
    "1766": "Verlorene Items",
    "1767": "Verlorene Items",
    "1768": "Verlorene Items",
    "1769": "Verlorene Items",
    "1770": "???",
    "1771": "Urball",
    "1772": "???",
    "1773": "???",
    "1774": "???",
    "1775": "???",
    "1776": "Urerz",
    "1777": "Adamantkristall",
    "1778": "Wei\u00dfkristall",
    "1779": "Platinumkristall",
    "1780": "Neutraltafel",
    "1781": "???",
    "1782": "Handwerkskiste",
    "1783": "Zentnerball",
    "1784": "Tonnenball",
    "1785": "R\u00e4tselball",
    "1786": "Pokédex",
    "1787": "Altes Gedicht 1",
    "1788": "Altes Gedicht 2",
    "1789": "Altes Gedicht 3",
    "1790": "Altes Gedicht 4",
    "1791": "???",
    "1792": "Altes Gedicht 5",
    "1793": "Altes Gedicht 6",
    "1794": "Altes Gedicht 7",
    "1795": "Altes Gedicht 8",
    "1796": "Altes Gedicht 9",
    "1797": "Altes Gedicht 10",
    "1798": "Altes Gedicht 11",
    "1799": "Altes Gedicht 12",
    "1800": "Altes Gedicht 13",
    "1801": "Altes Gedicht 14",
    "1802": "Altes Gedicht 15",
    "1803": "Altes Gedicht 16",
    "1804": "Altes Gedicht 17",
    "1805": "Altes Gedicht 18",
    "1806": "Altes Gedicht 19",
    "1807": "Altes Gedicht 20",
    "1808": "Enigmafragment S",
    "1809": "Enigmafragment L",
    "1810": "Einwegbohrer",
    "1811": "Kanto-Platte",
    "1812": "Johto-Platte",
    "1813": "Gef\u00fchlsplatte",
    "1814": "Regenbogenplatte",
    "1815": "Sturmplatte",
    "1816": "Meeresplatte",
    "1817": "Kontinentplatte",
    "1818": "Himmelsplatte",
    "1819": "Genplatte",
    "1820": "Weisungsplatte",
    "1821": "Zerrplatte",
    "1822": "DS-Player",
    "1828": "Legendentafel",
    "1842": "Minibambusspross",
    "1843": "Riesenbambusspross",
    "1861": "Fluchr\u00fcstung",
    "1862": "Tera-St\u00fcck (Normal)",
    "1863": "Tera-St\u00fcck (Feuer)",
    "1864": "Tera-St\u00fcck (Wasser)",
    "1865": "Tera-St\u00fcck (Elektro)",
    "1866": "Tera-St\u00fcck (Pflanze)",
    "1867": "Tera-St\u00fcck (Eis)",
    "1868": "Tera-St\u00fcck (Kampf)",
    "1869": "Tera-St\u00fcck (Gift)",
    "1870": "Tera-St\u00fcck (Boden)",
    "1871": "Tera-St\u00fcck (Flug)",
    "1872": "Tera-St\u00fcck (Psycho)",
    "1873": "Tera-St\u00fcck (K\u00e4fer)",
    "1874": "Tera-St\u00fcck (Gestein)",
    "1875": "Tera-St\u00fcck (Geist)",
    "1876": "Tera-St\u00fcck (Drache)",
    "1877": "Tera-St\u00fcck (Unlicht)",
    "1878": "Tera-St\u00fcck (Stahl)",
    "1879": "Tera-St\u00fcck (Fee)",
    "1880": "Energiekapsel",
    "1881": "F\u00e4higkeitenschild",
    "1882": "Neutralschmuck",
    "1883": "Kopierkraut",
    "1884": "Boxhandschuh",
    "1885": "Tarnumhang",
    "1886": "Gezinkter W\u00fcrfel",
    "2160": "TM100",
    "2161": "TM101",
    "2162": "TM102",
    "2163": "TM103",
    "2164": "TM104",
    "2165": "TM105",
    "2166": "TM106",
    "2167": "TM107",
    "2168": "TM108",
    "2169": "TM109",
    "2170": "TM110",
    "2171": "TM111",
    "2172": "TM112",
    "2173": "TM113",
    "2174": "TM114",
    "2175": "TM115",
    "2176": "TM116",
    "2177": "TM117",
    "2178": "TM118",
    "2179": "TM119",
    "2180": "TM120",
    "2181": "TM121",
    "2182": "TM122",
    "2183": "TM123",
    "2184": "TM124",
    "2185": "TM125",
    "2186": "TM126",
    "2187": "TM127",
    "2188": "TM128",
    "2189": "TM129",
    "2190": "TM130",
    "2191": "TM131",
    "2192": "TM132",
    "2193": "TM133",
    "2194": "TM134",
    "2195": "TM135",
    "2196": "TM136",
    "2197": "TM137",
    "2198": "TM138",
    "2199": "TM139",
    "2200": "TM140",
    "2201": "TM141",
    "2202": "TM142",
    "2203": "TM143",
    "2204": "TM144",
    "2205": "TM145",
    "2206": "TM146",
    "2207": "TM147",
    "2208": "TM148",
    "2209": "TM149",
    "2210": "TM150",
    "2211": "TM151",
    "2212": "TM152",
    "2213": "TM153",
    "2214": "TM154",
    "2215": "TM155",
    "2216": "TM156",
    "2217": "TM157",
    "2218": "TM158",
    "2219": "TM159",
    "2220": "TM160",
    "2221": "TM161",
    "2222": "TM162",
    "2223": "TM163",
    "2224": "TM164",
    "2225": "TM165",
    "2226": "TM166",
    "2227": "TM167",
    "2228": "TM168",
    "2229": "TM169",
    "2230": "TM170",
    "2231": "TM171",
    "2232": "TM172",
    "2233": "TM173",
    "2234": "TM174",
    "2235": "TM175",
    "2236": "TM176",
    "2237": "TM177",
    "2238": "TM178",
    "2239": "TM179",
    "2240": "TM180",
    "2241": "TM181",
    "2242": "TM182",
    "2243": "TM183",
    "2244": "TM184",
    "2245": "TM185",
    "2246": "TM186",
    "2247": "TM187",
    "2248": "TM188",
    "2249": "TM189",
    "2250": "TM190",
    "2251": "TM191",
    "2252": "TM192",
    "2253": "TM193",
    "2254": "TM194",
    "2255": "TM195",
    "2256": "TM196",
    "2257": "TM197",
    "2258": "TM198",
    "2259": "TM199",
    "2260": "TM200",
    "2261": "TM201",
    "2262": "TM202",
    "2263": "TM203",
    "2264": "TM204",
    "2265": "TM205",
    "2266": "TM206",
    "2267": "TM207",
    "2268": "TM208",
    "2269": "TM209",
    "2270": "TM210",
    "2271": "TM211",
    "2272": "TM212",
    "2273": "TM213",
    "2274": "TM214",
    "2275": "TM215",
    "2276": "TM216",
    "2277": "TM217",
    "2278": "TM218",
    "2279": "TM219",
    "2280": "TM220",
    "2281": "TM221",
    "2282": "TM222",
    "2283": "TM223",
    "2284": "TM224",
    "2285": "TM225",
    "2286": "TM226",
    "2287": "TM227",
    "2288": "TM228",
    "2289": "TM229",
    "2344": "Glorienr\u00fcstung",
    "2345": "Anf\u00fchrersymbol",
    "2401": "Feendaune",
    "2402": "Saftiger Apfel",
    "2403": "Simple Teeschale",
    "2404": "Edle Teeschale",
    "2405": "T\u00fcrkisgr\u00fcne Maske",
    "2406": "Fundamentmaske",
    "2407": "Brunnenmaske",
    "2408": "Ofenmaske",
    "2409": "Gr\u00fcne Style-Karte",
    "2410": "Kristallfragment",
    "2411": "Heil-Mochi",
    "2412": "Kraft-Mochi",
    "2413": "Abwehr-Mochi",
    "2414": "Genie-Mochi",
    "2415": "Esprit-Mochi",
    "2416": "Flink-Mochi",
    "2417": "Standard-St\u00fchle",
    "2418": "Akademie-St\u00fchle",
    "2419": "Akademie-St\u00fchle",
    "2420": "Zauber-St\u00fchle",
    "2421": "Natur-St\u00fchle",
    "2422": "Groll-St\u00fchle",
    "2423": "Gelbkaro-St\u00fchle",
    "2424": "Blaukaro-St\u00fchle",
    "2425": "Rotkaro-St\u00fchle",
    "2426": "Retro-Gras-St\u00fchle",
    "2427": "Action-St\u00fchle",
    "2428": "Ungeheuer-St\u00fchle",
    "2429": "Streifen-St\u00fchle",
    "2430": "Rauten-St\u00fchle",
    "2431": "Punkte-St\u00fchle",
    "2432": "Violette St\u00fchle",
    "2433": "T\u00fcrkise St\u00fchle",
    "2434": "Beige St\u00fchle",
    "2435": "Gelbe St\u00fchle",
    "2436": "Blaue St\u00fchle",
    "2437": "Pinke St\u00fchle",
    "2438": "Rettan-Zahn",
    "2439": "Sandan-Kralle",
    "2440": "Pii-Haar",
    "2441": "Vulpix-Haar",
    "2442": "Quapsel-Schleim",
    "2443": "Knofensa-Ranke",
    "2444": "Kleinstein-Splitter",
    "2445": "Smogon-Gas",
    "2446": "Mampfaxo-Zahn",
    "2447": "Wiesor-Haar",
    "2448": "Hoothoot-Feder",
    "2449": "Webarak-Faden",
    "2450": "Griffel-Haar",
    "2451": "Yanma-Stachel",
    "2452": "Skorgla-Zahn",
    "2453": "Schneckmag-Lava",
    "2454": "Quiekel-Haar",
    "2455": "Fiffyen-Zahn",
    "2456": "Loturzel-Blatt",
    "2457": "Samurzel-Zweig",
    "2458": "Nasgnet-Splitter",
    "2459": "Volbeat-Sekret",
    "2460": "Illumise-Sekret",
    "2461": "Krebscorps-Schale",
    "2462": "Barschwa-Schuppe",
    "2463": "Zwirrlicht-Splitter",
    "2464": "Klingplim-Splitter",
    "2465": "Praktibalk-Schwei\u00df",
    "2466": "Strawickl-Blatt",
    "2467": "Piccolente-Feder",
    "2468": "Lichtel-Ru\u00df",
    "2469": "Lin-Fu-Kralle",
    "2470": "Skallyk-Feder",
    "2471": "Rocara-Edelstein",
    "2472": "Paragoni-Zweig",
    "2473": "Mabula-Faden",
    "2474": "Wommel-Puder",
    "2475": "Miniras-Schuppe",
    "2476": "Urgl-Daune",
    "2477": "Morpeko-Samen",
    "2478": "Mortcha-Puder",
    "2479": "Neuanfangs-Mochi",
    "2480": "Rotom-Stick",
    "2481": "Glitzerpin",
    "2482": "Legierungsmetall",
    "2483": "Blaue Style-Karte",
    "2484": "Myrapla-Blatt",
    "2485": "Tentacha-Stachel",
    "2486": "Dodu-Daune",
    "2487": "Jurob-Haar",
    "2488": "Owei-Schale",
    "2489": "Rabauz-Schwei\u00df",
    "2490": "Rihorn-Zahn",
    "2491": "Seeper-Tinte",
    "2492": "Elekid-Haar",
    "2493": "Magby-Haar",
    "2494": "Lapras-Tr\u00e4ne",
    "2495": "Porygon-Splitter",
    "2496": "Lampi-Strom",
    "2497": "Snubbull-Haar",
    "2498": "Panzaeron-Feder",
    "2499": "Farbeagle-Tinte",
    "2500": "Plusle-Haar",
    "2501": "Minun-Haar",
    "2502": "Knacklion-Schale",
    "2503": "Tanhel-Kralle",
    "2504": "Koknodon-Stachel",
    "2505": "Schilterus-Kralle",
    "2506": "Elezeba-M\u00e4hnenhaar",
    "2507": "Rotomurf-Kralle",
    "2508": "Waumboll-Watte",
    "2509": "Zurrokex-Schwei\u00df",
    "2510": "Picochilla-Haar",
    "2511": "Monozyto-Gel",
    "2512": "Wattzapf-Faden",
    "2513": "Golbit-Splitter",
    "2514": "Psiau-Haar",
    "2515": "Iscalar-Tinte",
    "2516": "Peppeck-Feder",
    "2517": "Araqua-Faden",
    "2518": "Curelei-Bl\u00fcte",
    "2519": "Meteno-Schale",
    "2520": "Hokumil-Sahne",
    "2521": "Duraludon-Patina",
    "2522": "Arktos-Snack",
    "2523": "Zapdos-Snack",
    "2524": "Lavados-Snack",
    "2525": "Raikou-Snack",
    "2526": "Entei-Snack",
    "2527": "Suicune-Snack",
    "2528": "Lugia-Snack",
    "2529": "Ho-Oh-Snack",
    "2530": "Latias-Snack",
    "2531": "Latios-Snack",
    "2532": "Kyogre-Snack",
    "2533": "Groudon-Snack",
    "2534": "Rayquaza-Snack",
    "2535": "Kobalium-Snack",
    "2536": "Terrakium-Snack",
    "2537": "Viridium-Snack",
    "2538": "Reshiram-Snack",
    "2539": "Zekrom-Snack",
    "2540": "Kyurem-Snack",
    "2541": "Solgaleo-Snack",
    "2542": "Lunala-Snack",
    "2543": "Necrozma-Snack",
    "2544": "Dakuma-Snack",
    "2545": "Polaross-Snack",
    "2546": "Phantoross-Snack",
    "2547": "Indigoblaue Scheibe",
    "2548": "Flammen-Pikser",
    "2549": "Tera-St\u00fcck (Stellar)",
    "2550": "Chesnaughtite",
    "2551": "Clefablite",
    "2552": "Delphoxite",
    "2553": "Dragoninite",
    "2554": "Drampanite",
    "2555": "Emboarite",
    "2556": "Excadrillite",
    "2557": "Feraligite",
    "2558": "Floettite",
    "2559": "Greninjite",
    "2560": "Golurkite",
    "2561": "Hawluchanite",
    "2562": "Meganiumite",
    "2563": "Meowsticite",
    "2564": "Starmiite",
    "2565": "Victreebelite",
    "2566": "Skarmoryite",
    "2567": "Chandelurite",
    "2568": "Zygardite",
    "2569": "Glimmoranite",
    "2570": "Crabominite",
    "2571": "Raichuite X",
    "2572": "Raichuite Y",
    "2573": "Chimechite",
    "2574": "Absolite Z",
    "2575": "Staraptorite",
    "2576": "Garchompite Z",
    "2577": "Lucarionite Z",
    "2578": "Heatranite",
    "2579": "Darkranite",
    "2580": "Golisopite",
    "2581": "Magearnite",
    "2582": "Zeraorite",
    "2583": "Scovillainite",
    "2584": "Tatsugirite",
    "2585": "Baxcalibrite"
}
export default itemsGer;